import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url, URLS, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';
import ShopCard from '@wix/da-shared-react/pkg/ShopCard/DeviationShopCard';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import AddItemCard from '../../_partials/AddItemCard';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PremiumContentEmptyState from '../../_partials/PremiumContentEmptyState';
import PremiumContentSliderMobile from './PremiumContentSliderMobile';

export interface Props {
  streamId: string;
  moduleId: number;
  premiumContentDeviations: PapiDeviation[];
  total: number;
  isOwner: boolean;
  username: string;
  isMobile?: boolean;
}

export class PremiumContentSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation & WithFeatureFlagsProps
> {
  render() {
    const {
      isMobile,
      isOwner,
      streamId,
      t,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      premiumContentDeviations,
      total,
      username,
      section,
      zone,
    } = this.props;

    const isEmpty = !premiumContentDeviations.length;
    const showAddItemCard = isOwner;

    // dont show empty state - https://phrac.deviantart.net/T57297  & https://phrac.deviantart.net/T57418
    if (isEmpty && !isOwner) {
      return null;
    }

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('common.premiumContent')}
        count={total}
        moduleId={moduleId}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={<PremiumContentEmptyState view={'wide'} />}
        seeAllUrl={Url.userShopPath(
          username,
          USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT
        )}
        headerClassName={this.props.headerClassName}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={premiumContentDeviations}
          parent={{ title: t('duperbrowse.backButton.profile.shop') }}
        >
          {isMobile ? (
            <PremiumContentSliderMobile
              deviations={premiumContentDeviations}
              showAddItemCard={showAddItemCard}
            />
          ) : (
            <Slider
              renderSliderItems={elementSize => (
                <>
                  {showAddItemCard && (
                    <AddItemCard
                      title={t('pages.shop.premiumContent.addItem.title')}
                      subtitle={t('pages.shop.premiumContent.addItem.subtitle')}
                      onClick={() => window.location.replace(URLS.SUBMIT)}
                      nonCoreMembershipView={
                        <PremiumContentEmptyState view={'small'} />
                      }
                      biData={BiData<DefaultBiEvent>({
                        evid: 2,
                        click_info: 'create_premium_download',
                        sectionname: 'premium_download',
                      })}
                      view={'small'}
                    />
                  )}
                  {premiumContentDeviations.map(deviation => (
                    <ShopCard
                      key={deviation.deviationId}
                      width={elementSize.width}
                      deviation={deviation}
                      withAuthorDetails={false}
                    />
                  ))}
                </>
              )}
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(
  withFeatureFlags(withTranslation()(PremiumContentSlider))
);
